import { render, staticRenderFns } from "./DeleteWarningModal.vue?vue&type=template&id=ff00e136&scoped=true"
import script from "./DeleteWarningModal.vue?vue&type=script&lang=js"
export * from "./DeleteWarningModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteWarningModal.vue?vue&type=style&index=0&id=ff00e136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff00e136",
  null
  
)

export default component.exports